<template>
  <div class="pagination-container">
    <div class="icon-plus"></div>
    <div class="pagination-item" @click="changeIndex(index)" :class="{active:index == curIndex}" v-for="(item,index) in items" :key="index">
      <div class="item-text">   
        <span  v-for="(text,_index) in item.split(' ')" :key="_index">{{text}}</span>
      </div>
      <div class="circle"></div>
    </div>
  </div>
</template>
<script>
export default {
  name:'Pagination',
  components:{
  },
  methods:{
    changeIndex(index){
      this.$emit("update:curIndex",index);
    }
  },
  props:{
    items:{
      type:Array,
      required:true
    },
    curIndex:{
      type:Number,
      default:0,
      required:true
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../common/theme.scss";
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
}
.pagination-item {
  margin-left: 118px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  &.active {
    color: $themeColor;
    .circle {
      box-shadow: 0 0 0 4px rgba($themeColor,.3);
    }
  }
  &:before {
    content: "";
    width: 118px;
    height: 0;
    border: 1px dashed #000;
    position: absolute;
    left: -118px;
    top: 0;
    bottom: 0;
    margin: auto;
    z-index: 0;
  }
  &:last-child {
     &:after {
      content: "";
      width: 118px;
      height: 0;
      border: 1px dashed #000;
      position: absolute;
      right: -118px;
      top: 0;
      bottom: 0;
      margin: auto;
      z-index: 0;
    }
  }
  .circle {
    width: 12px;
    height:12px;
    background: #ee0a07;
    border-radius: 50%;
    z-index: 2;
    position: relative;
    transform: translate3d(0,0,0);
  }
  .item-text {
    position: absolute;
    white-space: nowrap;
    left: 50%;
    top: 0;
    transform: translate3d(-50%,-110%,0);
  }
  span {
    display: block;
  }
}
.icon-plus{
  display: inline-block;
  width: 0;
  height: 0;
  font-size: 0;
  position: relative;
  vertical-align: middle;
  margin-right: 11px;
  &:after,
  &:before{
    content: "";
    position: absolute;
    top:50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
    background-color: $themeColor;
  }
  &:after {
    width: 3px;
    height: 22px;
  }
  &:before {
    width: 22px;
    height: 3px;
  }
}
</style>
